import { Card, Typography } from "antd";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

const { Link } = Typography;

export const UserInfo = styled(FlexContainer)`
    padding-top: 32px;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;

export const TeamMemberBlock = styled.div`
    background-color: ${({ theme }) => theme.itemBackground};
    border: 1px solid #313131;
    border-radius: 10px;
    margin-bottom: 8px;
    display: flex;
    padding: 16px;
    gap: 8px;
    justify-content: space-between;
`;

export const InfoContainerList = styled(Card)`
    gap: 16px;
    border-radius: 10px;
    border: none;
    width: 100%;
`;

export const InfoContainerListTopBlock = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #313131;
    padding-bottom: 16px;
    gap: 12px;
`;

export const InfoContainerListCenterBlock = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #313131;
    padding: 16px 0;
    gap: 12px;
`;

export const InfoContainerListBottomBlock = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    gap: 12px;
`;

export const UserInfoTitle = styled(Typography)`
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
`;

export const UserInfoDescriptionLink = styled(Link)`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    && {
        color: ${(props) => props.theme.secondaryTypographyColor}!important;
    }
`;

export const UserInfoDescriptionText = styled(Typography)`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    && {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
`;
